(function () {
  "use strict";

  var cartTimers = new Set();
  var cartWarningShown = false;
  var cartBadgeRequest;
  var cartBadgeVersion = 0;
  var cartBadgeSuspended = false;

  function cancelCartBadgeRequest() {
    cartBadgeVersion += 1;
    if (cartBadgeRequest) cartBadgeRequest.abort();
    cartBadgeRequest = undefined;
  }

  function cartBadgeUrl() {
    var routes = document.querySelector('[data-cart-routes]');
    try {
      if (!routes) throw new Error('Cart routes are unavailable.');
      var path = JSON.parse(routes.textContent).cartUrl;
      if (typeof path !== 'string' || !/^\/(?:[A-Za-z0-9_-]+\/)*cart$/.test(path)) {
        throw new Error('Expected a local cart path without query, fragment or escape characters.');
      }
      var url = new URL(path + '.js', window.location.origin);
      if (url.origin !== window.location.origin) throw new Error('Expected a same-origin cart route.');
      return url.href;
    } catch (error) {
      console.warn('WhiteTail: the cart badge route could not be read.', error);
      return null;
    }
  }

  async function refreshCartBadge() {
    if (cartBadgeSuspended) return;
    cancelCartBadgeRequest();
    if (!document.querySelectorAll('[data-cart-count]').length && !document.querySelectorAll('[data-cart-count-bubble]').length) return;
    var url = cartBadgeUrl();
    if (!url) return;
    var version = cartBadgeVersion;
    var controller = new AbortController();
    cartBadgeRequest = controller;
    try {
      var response = await fetch(url, { method: 'GET', credentials: 'same-origin', mode: 'same-origin', cache: 'no-store', signal: controller.signal });
      if (!response.ok) throw new Error('The cart badge request was not successful.');
      var cart = await response.json();
      if (!cart || !Number.isSafeInteger(cart.item_count) || cart.item_count < 0) throw new Error('The cart response has no valid item count.');
      if (controller.signal.aborted || version !== cartBadgeVersion || cartBadgeSuspended) return;
      var counts = document.querySelectorAll('[data-cart-count]');
      for (var index = 0; index < counts.length; index += 1) counts[index].textContent = String(cart.item_count);
      var bubbles = document.querySelectorAll('[data-cart-count-bubble]');
      for (var bubbleIndex = 0; bubbleIndex < bubbles.length; bubbleIndex += 1) {
        if (cart.item_count === 0) bubbles[bubbleIndex].classList.add('hide');
        else bubbles[bubbleIndex].classList.remove('hide');
        var oldCountPhrase = bubbles[bubbleIndex].querySelector('.icon__fallback-text');
        if (oldCountPhrase) oldCountPhrase.setAttribute('aria-hidden', 'true');
      }
    } catch (error) {
      if (!controller.signal.aborted && version === cartBadgeVersion && !cartBadgeSuspended) {
        console.warn('WhiteTail: the confirmed cart update could not refresh its header badge.', error);
      }
    } finally {
      if (cartBadgeRequest === controller) cartBadgeRequest = undefined;
    }
  }

  // Added line items are not a cart total; read Shopify's authoritative count after confirmation.
  document.addEventListener('wt:cart-changed', refreshCartBadge);
  window.addEventListener('pageshow', function () { cartBadgeSuspended = false; });

  function refreshCart(open) {
    if (typeof window.SLIDECART_UPDATE === "function") {
      window.SLIDECART_UPDATE();
    } else if (!cartWarningShown) {
      console.warn("WhiteTail: the AMP cart is not ready; the product form remains responsible for adding the item.");
      cartWarningShown = true;
    }
    if (open && typeof window.SLIDECART_OPEN === "function") {
      window.SLIDECART_OPEN();
    }
  }

  // Keep the existing PageFly-to-AMP refresh timing without replacing window.onload.
  document.addEventListener("click", function (event) {
    if (!(event.target instanceof Element)) return;
    var button = event.target.closest('[data-pf-type="ProductATC"], [data-pf-type="ProductATC2"]');
    if (!button || button.disabled || button.getAttribute("aria-disabled") === "true") return;
    [400, 800, 1200].forEach(function (delay, index) {
      var timer = window.setTimeout(function () {
        cartTimers.delete(timer);
        if (event.defaultPrevented) return;
        refreshCart(index === 0);
      }, delay);
      cartTimers.add(timer);
    });
  }, true);

  function revealAddressErrors(root) {
    var forms = root.querySelectorAll("[data-wt-address-form]");
    var firstError = null;
    for (var index = 0; index < forms.length; index += 1) {
      var error = forms[index].querySelector(".form-message--error[data-form-status]");
      if (!error) continue;
      forms[index].classList.remove("hide");
      var toggle = document.getElementById(forms[index].dataset.wtAddressToggle);
      if (toggle) toggle.setAttribute("aria-expanded", "true");
      if (!firstError) firstError = error;
    }
    if (firstError) {
      firstError.setAttribute("tabindex", "-1");
      firstError.focus();
    }
  }

  function initialize() {
    revealAddressErrors(document);
  }

  document.addEventListener("shopify:section:load", function (event) {
    revealAddressErrors(event.target);
  });
  window.addEventListener("pagehide", function () {
    cartBadgeSuspended = true;
    cancelCartBadgeRequest();
    cartTimers.forEach(function (timer) { window.clearTimeout(timer); });
    cartTimers.clear();
  });

  if (document.readyState !== "complete") {
    document.addEventListener("DOMContentLoaded", initialize, { once: true });
  } else {
    initialize();
  }
})();
